import $ from "cash-dom";

export default class FormModule {

    static name = 'form'

    constructor(node) {

        const $form = $(node);
        const wait = 10;
        let timeout = null;

        $form.on('submit', function(e) {

            e.preventDefault();

            const url = $form.attr('action');
            const method = $form.attr('method');

            const fetchOptions = {
                method: method,
                headers: {
                  'Accept': 'application/json'
                }
            };

            if(method === 'post') {
                fetchOptions.body = new FormData(node);
            }
            
            $form.find('.form__error, .form__success').hide();            
            $form.find('input, button, textarea').attr('disabled', true);
            
            timeout = window.setTimeout(function() {
                $form.find('.form__error').show();
                $form.find('input, button, textarea').hide();
            }, wait * 1000);

            //emo does not work inside form right now so yeah ... copy and pasta
            const $formEmail = $form.prev('.js-contactsrc');
            if($formEmail.length) {
                const email = $formEmail.html();
                $form.find('.js-contactemail').html(email);
            }

            fetch(url, fetchOptions)
            .then(res => res.json())
            .then(data => {
                //console.log('fetch json response', data);

                window.clearTimeout(timeout);

                if(data.success) {
                    $form.find('.form__success').show();
                    $form.find('input, button, textarea').hide();
                } else {
                    $form.find('.form__error').show();
                    $form.find('input, button, textarea').removeAttr('disabled');
                }
            })
            .catch(e => {
                $form.find('.form__error').show();
                $form.find('input, button, textarea').hide();
            })
        });
    }
}